<template>
  <div>
    <b-row class="content-header mb-2">
      <b-col class="col-md-6">
        <h2 class="content-header-title float-left pr-1 mb-0">Farm</h2>
      </b-col>
    </b-row>

    <b-card no-body class="cardBody">
      <div class="d-flex justify-content-end">
        <b-button
          v-if="hasPermission('add_farm')"
          variant="primary"
          :to="{ name: 'apps-farm-add' }"
          class="mr-2 mt-3 custom-btn"
        >
          <feather-icon icon="PlusIcon" class="mr-25" />
          Add Farm
        </b-button>
      </div>

      <div v-if="farm_list.length > 0" class="farm-grid">
        <div v-for="item in farm_list" :key="item.id" class="farm-card">
          <div
            class="farm-card-head"
            :class="item.status === 'Inactive' ? 'is-inactive' : 'is-active'"
          >
            <div class="farm-card-icon">
              <feather-icon icon="HomeIcon" size="20" />
            </div>
            <div class="farm-card-title">
              <h5 :title="item.name">{{ item.name }}</h5>
              <span v-if="item.address" :title="item.address">{{ item.address }}</span>
            </div>
            <span class="farm-card-status">
              {{ item.status === 'Inactive' ? 'Inactive' : 'Active' }}
            </span>
          </div>

          <div class="farm-card-body">
            <div class="farm-row">
              <span>Sheds</span>
              <strong>{{ item.shedCount != null ? item.shedCount : 0 }}</strong>
            </div>
            <div class="farm-row">
              <span>Created by</span>
              <strong>{{ item.createdBy || '—' }}</strong>
            </div>
            <div class="farm-row">
              <span>Created</span>
              <strong>{{ setDateFormat(item.created_at) }}</strong>
            </div>
          </div>

          <div class="farm-card-actions">
            <b-link
              v-if="hasPermission('update_farm')"
              class="farm-action"
              :to="{ name: 'apps-farm-edit', params: { farmId: `${item.id}` } }"
            >
              <feather-icon icon="EditIcon" size="15" /> Edit
            </b-link>
            <b-link class="farm-action" @click="farmView(item.id)">
              <feather-icon icon="EyeIcon" size="15" /> Sheds
            </b-link>
          </div>
        </div>
      </div>

      <div v-else class="d-flex flex-column align-items-center py-5">
        <b-img :src="require('@/assets/images/svg/infographics/no_data_infographic.svg')" class="mr-2" />
        <h4 class="mt-2 Secondary">There is No list of Farm</h4>
      </div>
    </b-card>
  </div>
</template>

<script>
import { avatarText } from "@core/utils/filter";
import vSelect from "vue-select";

import axiosIns from "@/libs/axios";

export default {
  components: {
    vSelect,
  },
  created() {
    this.companyId = this.$route.params.companyId;
    this.getUserFarm();
  },
  data() {
    return {
      selected: null,
      farm_id: null,
      farm_list: [],
      farm: null,
      farm_machine: null,
      length: null,
      farm_name: null,
      companyId: null,
      farmId: null,
    };
  },
  methods: {
    getUserFarm() {
      let companyId = this.companyId;
      let url = "";
      if (companyId) {
        url = `web/company/${companyId}/getUserFarmList`;
      } else {
        url = `web/getUserFarmList`;
      }
      axiosIns
        .get(url)
        .then((response) => {
          this.farm_list = response.data.user_farm_list;
        })
        .catch((error) => {
          this.$toast &&
            this.$toast({
              props: {
                title: error.response?.data?.message || "Unable to load farms.",
                variant: "danger",
                icon: "AlertTriangleIcon",
              },
            });
        });
    },
    farmView(farmId) {
      this.$router.push({ path: `/apps/farm/${farmId}/view` });
    },
  },
};
</script>

<style lang="scss" scoped>
.farm-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 1.25rem;
  padding: 1.5rem;
}

.farm-card {
  background: #fff;
  border: 1px solid #ebe9f1;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(34, 41, 47, 0.06);
  transition: box-shadow 0.2s ease, transform 0.1s ease;

  &:hover {
    box-shadow: 0 8px 20px rgba(41, 109, 180, 0.16);
  }
}

.farm-card-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;

  &.is-active {
    background: #296db4;
  }
  &.is-inactive {
    background: #ea5455;
  }
}

.farm-card-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.farm-card-title {
  flex: 1;
  min-width: 0;

  h5 {
    margin: 0;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  span {
    display: block;
    color: rgba(255, 255, 255, 0.85);
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.farm-card-status {
  flex: 0 0 auto;
  font-size: 10px;
  color: #fff;
  background: rgba(255, 255, 255, 0.25);
  padding: 2px 9px;
  border-radius: 20px;
}

.farm-card-body {
  padding: 8px 16px;
}

.farm-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 13px;

  span {
    color: #6e6b7b;
  }
  strong {
    color: #5e5873;
    font-weight: 600;
  }

  & + .farm-row {
    border-top: 0.5px solid #f3f2f7;
  }
}

.farm-card-actions {
  display: flex;
  border-top: 1px solid #ebe9f1;

  .farm-action {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 11px;
    font-size: 13px;
    color: #296db4;
    transition: background 0.15s ease;

    &:hover {
      background: rgba(41, 109, 180, 0.06);
    }

    & + .farm-action {
      border-left: 1px solid #ebe9f1;
    }
  }
}
</style>
